module.exports = __webpack_public_path__ + "logo.719885b1.jpg";